//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import address from '@/mock/address.js'
  import downloadImgs from '@/mixins/downloadImgs'
  export default {
    mixins: [downloadImgs],
    data() {
      return {
        value: {
          tenantId: "",
          type: "address",
          province: "",
          city: "",
          region: "",
          content: "",
        },
        currentValue: [],
        myAddress: "",
        isCheck: true
      }
    },
    props: {
      question: {
        type: Object,
        default () {
          return {}
        }
      },
      index: {
        type: Number
      },
      readonly: {
        type: Boolean
      },
      showScore: {
        type: Boolean,
        default: false,
      },
    },
    computed: {},
    mounted() {
      console.log(1, this.readonly)
      this.question.v_answered && this.setHistroyAnswer()
    },
    methods: {
      select() {
        let col = this.question.level === '4' ? 3 : Number(this.question.level)
        new this.$Picker({
          value: this.currentValue,
          data: address,
          title: {
            text: '地址选择'
          },
          dataValue: 'name',
          dataText: 'name',
          col,
          cascade: true,
          rootRule: item => {
            return item.parentId === "0"
          },
          onOk: (values, text, selectedIndex) => {
            this.currentValue = values
            this.setAddress(values, col)
            this.setAnswer()
            this.$emit("onSelectChange")
          }
        })
      },
      setAddress(values, col) {
        this.value.tenantId = this.question.tenantId;
        ["province", "city", "region"]
        .splice(0, this.question.level == 4 ? 3 : this.question.level)
        .forEach((v, i) => {
          this.value[v] = values[i]
        })
      },
      changeAddress(e) {
        this.value.content = e
        this.setAnswer()
        this.$emit("onSelectChange")
      },
      setAnswer() {
        // 设置题目答案
        this.$store.commit('setQuestionAnswered', {
          index: this.index,
          v_answered: true
        })
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer: this.value
        })
        // 如果当前为校验状态  则更新校验状态
        !this.isCheck && (this.isCheck = this.validate())
      },
      setHistroyAnswer(){
        this.value = this.question.v_answer
        this.myAddress = this.value.content
      },
      clear(){
        this.value = {
          tenantId: "",
          type: "address",
          province: "",
          city: "",
          region: "",
          content: "",
        }
        this.currentValue = []
        this.setAnswer()
        // 如果当前为校验状态  则更新校验状态
        !this.isCheck && (this.isCheck = this.validate())
      },
      validate() {
        // 非必填跳过校验
        console.log("required: ", this.question.required)
        if(!this.question.required) return true

        let checkArr = ["province", "city", "region", "content"].splice(0, this.question.level)
        for (let i = 0; i < checkArr.length; i++) {
          if (!this.value[checkArr[i]]) {
            this.isCheck = false
            return false
          }
        }
        // 设置题目已答
        this.$store.commit('setQuestionAnswered', {
          index: this.index,
          v_answered: true
        })
        return true
      }
    }
  }
